import { useState } from "react"
import { Button, PanelSection, TabControl } from "@tm/controls"
import { useLocalization } from "@tm/localization"
import { useActions } from "@tm/morpheus"
import { useSelector } from "react-redux"
import { Box, Modal } from "@tm/components"
import { RimDriveRightTyres, RimSensors, RimVehicleInformation } from "."
import { tabs } from "../../../data/helpers/mocks"
import { NavigationItem } from "../../../data/model"
import { MainState } from "../../main"
import { Actions } from "../business"
import { getBundleParams } from "../../../utils"
import RimVehicleInfoLKQ from "./wheels-list-modal/rimVehicleInfoLKQ"
import RimStandardTyres from "./wheels-list-modal/rimStandardTyres"

export default function RimInfo() {
    const { translateText } = useLocalization()
    const showRimInfo = useSelector((s: MainState) => s.wheelsList.base.showRimInfo)
    const actions = useActions(Actions, "changeRimInfoAndSettingVisibility")
    const [selectedTab, setSelectedTab] = useState("VehicleInfo")
    const isLKQ = getBundleParams()?.version === "LKQ"

    const renderNavigationItem = (item: NavigationItem, idx: number) => {
        return (
            <TabControl.Tab identifier={item.path} key={idx}>
                {translateText(item.translationId)}
            </TabControl.Tab>
        )
    }

    const onClose = () => {
        actions.changeRimInfoAndSettingVisibility(false, false)
    }

    if (!showRimInfo) {
        return null
    }

    if (isLKQ) {
        return (
            <Modal open={showRimInfo} onOutsideClick={() => onClose()} percentWidth={60}>
                <Box padding="1em 2em">
                    <RimVehicleInfoLKQ />
                    <RimStandardTyres />
                </Box>
            </Modal>
        )
    }

    return (
        <PanelSection className="rim_info">
            <div className="rim-info__header">
                <TabControl selectedTabIdentifier={selectedTab} onTabSelect={setSelectedTab}>
                    {tabs.map(renderNavigationItem)}
                </TabControl>
                <Button onClick={onClose} layout={["ghost"]} icon="close" />
            </div>
            <div className="rim-info__content">
                {selectedTab == "VehicleInfo" && <RimVehicleInformation />}
                {selectedTab == "SeriesTires" && <RimDriveRightTyres />}
                {selectedTab == "Rdks" && <RimSensors />}
            </div>
        </PanelSection>
    )
}
